export default __webpack_public_path__ + "static/media/hide.55ba58f7.svg";